import React from "react";
import { inputCls } from "./ui";

export default function HousingSelect({ properties, value, onChange }) {
  const v = value || {};
  const prop = properties.find((p) => p.id === v.property_id);
  const room = prop?.rooms.find((r) => r.id === v.room_id);
  const free = (b) => !b.staff_hold && (!b.occupant || b.id === v.bed_id);
  return (
    <div className="grid sm:grid-cols-3 gap-2">
      <select data-testid="housing-property" value={v.property_id || ""} className={inputCls}
        onChange={(e) => onChange({ property_id: e.target.value || null, room_id: null, bed_id: null })}>
        <option value="">No housing</option>
        {properties.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
      {prop && (
        <select data-testid="housing-room" value={v.room_id || ""} className={inputCls}
          onChange={(e) => onChange({ ...v, room_id: e.target.value || null, bed_id: null })}>
          <option value="">Room</option>
          {prop.rooms.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
      )}
      {room && (
        <select data-testid="housing-bed" value={v.bed_id || ""} className={inputCls}
          onChange={(e) => onChange({ ...v, bed_id: e.target.value || null })}>
          <option value="">Bed</option>
          {room.beds.filter(free).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      )}
    </div>
  );
}
